module.exports = __webpack_public_path__ + "assets/img/year-title-bg2.c32e816c.png";